export enum SecondFactorIconEnum {
    securePassword = 'ico-password-approved',
    debitCardPassword = 'ico-card',
    token = 'ico-password-lock',
    questions= 'ico-question'
}



// WEBPACK FOOTER //
// ./src/app/bdb-second-factor-selector/models/second-factor-icon-enum.ts